import QuantityProduct from './QuantityProduct'

class RetouchedEveningPhotoProduct extends QuantityProduct {}

export default RetouchedEveningPhotoProduct
